import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/ui/home.component';
import { InsuranceTypesComponent } from './features/insurance-types/ui/insurance-types.component';
import { SummaryComponent } from './features/summary/summary.component';
import { CheckoutComponent } from './features/checkout/checkout.component';
import { QuoteLayoutComponent } from './common/components/quote-layout/quote-layout.component';
import { resetQuoteGuard } from './features/home/guards/reset-quote.guard';
import { QuoteSuccessComponent } from './features/quote-success/ui/quote-success.component';
import { quoteIssuedGuard } from './features/quote/guards/quote-issued.guard';
import { quoteNotIssuedGuard } from './features/quote/guards/quote-not-issued.guard';
import { quoteExistsGuard } from './features/quote/guards/quote-exists.guard';
import { LoginFailedComponent } from './features/auth/ui/login-failed/login-failed.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [resetQuoteGuard],
  },
  {
    path: 'auth/login-failed',
    component: LoginFailedComponent,
  },
  {
    path: 'quote',
    component: QuoteLayoutComponent,
    children: [
      {
        path: 'insurance-types',
        component: InsuranceTypesComponent,
        canActivate: [quoteExistsGuard, quoteNotIssuedGuard],
      },
      {
        path: 'summary',
        component: SummaryComponent,
        canActivate: [quoteExistsGuard, quoteNotIssuedGuard],
      },
      {
        path: 'checkout',
        component: CheckoutComponent,
        canActivate: [quoteExistsGuard, quoteNotIssuedGuard],
      },
      {
        path: 'success',
        component: QuoteSuccessComponent,
        canActivate: [quoteIssuedGuard],
      },
    ],
  },
];
